import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ProductionGamePageService } from '@features/games/services/production-game-page.service';
import { WebFullPageLayoutComponent } from '@layouts/pages/web-full-page-layout/web-full-page-layout.component';
import { Observable } from 'rxjs';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { ProductionGameDetailsPage } from '@features/games/models/production-game-details-page';
import { GameRankingService } from '@features/games/services/game-ranking.service';
import { GameRatingService } from '@features/games/services/game-rating.service';

@Component({
  selector: 'app-production-game-page',
  imports: [CommonModule, RouterModule, WebFullPageLayoutComponent],
  templateUrl: './production-game-page.component.html',
  styleUrl: './production-game-page.component.scss',
  providers: [GameRankingService, GameRatingService, ProductionGamePageService]
})
export class ProductionGamePageComponent implements OnInit {

  private route = inject(ActivatedRoute);
  private breakpointObserver = inject(BreakpointObserver);
  private productionGamePageService = inject(ProductionGamePageService);

  private id?: string;
  public page$?: Observable<ProductionGameDetailsPage>;
  public isHandset: boolean = false;

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => { 
      this.isHandset = state.matches; 
    }); 
      
    this.breakpointObserver .observe([ Breakpoints.Tablet, Breakpoints.Web, Breakpoints.WebLandscape ]).subscribe((state: BreakpointState) => { 
      this.isHandset = !state.matches; 
    });

    this.route.paramMap.subscribe(params => {
      this.id = params.get('gameDetailsId') ?? undefined;
      if (this.id) {
        this.page$ = this.productionGamePageService.getPage(this.id);
      }
    });
  }

  public share(): void {
    if (!this.id) return;
    
    this.productionGamePageService.Share({
      gameDetailsId: this.id
    });
  }

}
